import { Bar } from 'public/charting_library/charting_library';
import { getHistoricalDataHoldStation } from './holdstation';

export async function getHistoricalDataOkx(opts: {
    symbol: string;
    interval: string;
    limit: number;
    from?: number;
    to?: number;
}): Promise<Bar[]> {
    const instId = `${opts.symbol.replace('USDT', '-USDT')}`;

    const queryParams: Record<string, any> = {
        instId,
        bar: opts.interval,
        limit: `${opts.limit}`,
    };

    if (opts?.to) {
        queryParams.after = opts.to;
    }

    const url = `https://www.okx.com/api/v5/market/candles?${new URLSearchParams(
        queryParams
    ).toString()}`;

    try {
        const response = await fetch(url);
        const json = await response.json();

        if (json.code !== '0') {
            throw new Error(`OKX API error: ${json.msg}`);
        }

        const candles = json.data;

        const bars: Bar[] = candles
            .map((o: any) => {
                const time = Number(o[0]);

                if (!time || isNaN(time)) {
                    console.warn('Invalid time value:', o[0]);
                    throw new Error(`Invalid time value: ${o[0]}`);
                }

                return {
                    time,
                    open: parseFloat(o[1]),
                    high: parseFloat(o[2]),
                    low: parseFloat(o[3]),
                    close: parseFloat(o[4]),
                    volume: parseFloat(o[5]),
                };
            })
            .sort(
                (a: { time: number }, b: { time: number }) => a.time - b.time
            );

        return bars;
    } catch {
        return getHistoricalDataHoldStation(opts);
    }
}
